import { inject, Pipe, type PipeTransform } from '@angular/core';

import { type NgxMaskConfig, NgxMaskPipe } from 'ngx-mask';

@Pipe({
  name: 'ksMask',
})
export class MaskPipe implements PipeTransform {
  private readonly ngxMaskPipe = inject(NgxMaskPipe);

  transform(value: unknown, mask: string, config?: Partial<NgxMaskConfig>): string {
    if (value == null || value === '') return '';
    if (typeof value !== 'string' && typeof value !== 'number') return '';

    return this.ngxMaskPipe.transform(value, mask, config);
  }
}
